import React, { useEffect, useState } from 'react';
import {Grid,Card,CardContent,CardActions,Button} from '@material-ui/core';
import AspectRatioContainer from '../aspect-ratio-container/AspectRatioContainer';
import EirValidImage from '../eir-valid-image/EirValidImage';
import DeviceNotification from '../eir-device-notification/DeviceNotification';
import FormattedPrice from '../formatted-price/FormattedPrice';
import EirColourSelector from '../colour-selector/EirColourSelector';
import { useApolloClient } from '@apollo/client';
import ENDPOINT from '../graphql/GraphQLConstants';

function EirHandsetCard(props){
    const[selectedVariant,setSelectedVariant]=useState([]);
    const[imgPath,setImgPath]=useState('');
    const[redirectPath,setRedirectPath]=useState('');
    const graphql = useApolloClient();
    useEffect( ()=>{
        //console.log('Handset props>>',props);
        var varient='';
        for (let i = 0; i < props.device.variants.length; i++) {
            if (props.device.variants[i].inStock) {
                varient=props.device.variants[i];
                setSelectedVariant(varient);
            }
        } 
        if(varient==''){
            varient=props.device.variants[0];
            setSelectedVariant(varient);
        }       
        if (!varient.image || !varient.image.path) {
            setImgPath('/.galleries/eir/devices/handset_not_found.png');
            } 
            else {
                setImgPath(varient.image.path);
            }
        if(props.device.url==null){
            var deviceName = props.device.name.replaceAll(' ','-');
            setRedirectPath('/mobile/phones/prepay/details?name='+deviceName);
        }else{
            setRedirectPath(props.device.url);
        }
    },[]);
    const setVariant = selectedVariant => {
        setSelectedVariant(selectedVariant);        
        setImgPath(selectedVariant.image.path);
      };
      //console.log('selectedVariant>>',selectedVariant);
      const selectPhone=(deviceId)=>{
        localStorage.removeItem('ACQ_PROSPECTUUID'); 
        localStorage.removeItem('CO_REF');
        localStorage.removeItem('CS_REF');
        localStorage.removeItem('ACQ_PORTIN');
        localStorage.setItem('prepayHandsetId',deviceId);
        window.location.href=redirectPath;
      };
    

      
    return (
        
        <Grid xs={6} sm={4} className='device-position'>
            <Card variant="outlined" className="eir-mobile-device-listing eir-card mb-4 mb-md-5 mb-lg-6 card-overlay">
                <CardContent className="eir-card-body">
                    <a  className="d-block pl-3 pr-3 pb-2 pl-md-4 pr-md-4 pb-md-3" onClick={() => {selectPhone(props.device.id)}}>
                        <AspectRatioContainer xs="10-16" > 
                            {imgPath || imgPath!==''?<EirValidImage className="img-fluid" src={imgPath}  fallbackSrc='/.galleries/eir/devices/handset_not_found.png' />:''}
                             {/* <EirValidImage className="img-fluid" src={imgPath}  fallbackSrc='/.galleries/eir/devices/handset_not_found.png' /> */}
                        </AspectRatioContainer>
                    </a>
                    <div className="d-flex justify-content-between div-gap">  
                        <h6 className="h6-text text-uppercase mb-md-3">{props.device.manufacturer}</h6>                        
                    </div>                     
                    <h4 className="h4-text text-black device-padding-rem mb-md-4">{props.device.displayName || props.device.model}</h4>
                    <div>
                        <h6 className="text-uppercase danger-text danger-height-reduce mb-md-3">{selectedVariant == null ? selectedVariant.stockStatus : selectedVariant.stockStatus}</h6>           
                    </div>
                    <div className="d-flex flex-column flex-sm-row justify-content-between price-height-reduce">                    
                        <EirColourSelector colourOptions={props.device.variants} selectedColour={selectedVariant} details={false} onColourSelected= {setVariant}/>
                        <FormattedPrice className="text-right price-text-handset" fromPrice={props.device.fromPrice} price={props.device.price} />
                    </div>    
                        <DeviceNotification className='device-notify' device={props.device} selectedVariant={selectedVariant}/>                   
                </CardContent>
                <CardActions className="eir-card-footer button-position">            
                    <Button
                    className="handset-button"
                    onClick={() => {selectPhone(props.device.id)}}>{props.ctaText} </Button>
                </CardActions>
            </Card>
        </Grid>        
      );
}
export default EirHandsetCard;